import { css } from "@emotion/react"

function MarginTopBlock(props: { top: number }) {
    return (
        <div
            css={css`
                margin-top: ${props.top}rem;
            `}
        />
    )
}

export default MarginTopBlock
